<title>{{ iagBookingPortalsPage.htmlTitle }}</title>
<div class="IagPortal">
  <div *ngFor="let iagpage of iagBookingPortalsPage.aboveIagTableSection">
    <div class="lightBlue flex">
      <h3>{{ iagpage.title }}</h3>
      <i class="{{ iagpage.sectionClass }}"></i>
    </div>
    <div *ngIf="iagpage.body" [innerHTML]="iagpage.body | mdToHtml"></div>
  </div>
<h2>{{iagLatestAPIProductUpdates}}</h2>
  <app-table-section [isIagPotalPage]="true" [iagProductUpdatesTitle]="iagRevisionNoticeTitle" [iagProductUpdate]="iagBookingPortalsPage.iagPortalRevisionNotices"></app-table-section>
  <div *ngIf="iagRevisionNoticeButton || iagRevisionNoticeUrl" class="row">
    <div class="col-sm-12 push-right">
     <a [href]="iagRevisionNoticeUrl" role="button"> {{ iagRevisionNoticeButton }} </a>
    </div>
  </div>
  <div  *ngFor="let iagpage of iagBookingPortalsPage.belowIagTableSection">
    <div class="lightBlue flex mt-3">
      <h3>{{ iagpage.title }}</h3>
      <i class="{{ iagpage.sectionClass }}"></i>
    </div>
    <div *ngIf="iagpage.body" [innerHTML]="iagpage.body | mdToHtml"></div>
  </div>

  <app-benefit-card [benefitCards]="iagBookingPortalsPage.benefitCards"></app-benefit-card>
</div>
